import { createCoreMethod } from '../../utils/createCoreMethod';

export const loadPage = createCoreMethod('loadPage', async () => {
  await figma.currentPage.loadAsync();
});
